module.exports = __webpack_public_path__ + "static/img/Encounter_a_Patient_for_Consultation.022cd00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Encounter_a_Patient_for_Consultation.jpg
// module id = 8sJ7
// module chunks = 0